module.exports = __webpack_public_path__ + "static/media/cnr_icon.7caa8493.svg";